import { render, staticRenderFns } from "./EditIncidentModal.vue?vue&type=template&id=00c4d04d&"
import script from "./EditIncidentModal.vue?vue&type=script&lang=js&"
export * from "./EditIncidentModal.vue?vue&type=script&lang=js&"
import style0 from "./EditIncidentModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports